export default function Order() {
    return (
        <>
        my order
        </>
    )
}